<template>
  <el-card>
    <div class="toolbar">
      <el-button type="success" @click="openCreate">新增群聊</el-button>
    </div>
    <el-table :data="list" v-loading="loading" border>
      <el-table-column prop="id" label="ID" width="70"></el-table-column>
      <el-table-column label="头像" width="80" align="center">
        <template slot-scope="s">
          <img v-if="s.row.avatar" class="group-avatar-thumb" :src="s.row.avatar">
          <span v-else class="muted">—</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="群聊名称">
        <template slot-scope="s">
          <span>{{ s.row.name }}</span>
          <el-tag v-if="s.row.isDefault === 1" type="success" size="mini" class="ml8">默认群</el-tag>
          <el-tag v-if="s.row.status === 1" type="info" size="mini" class="ml8">已关闭</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="玩法">
        <template slot-scope="s">{{ ruleName(s.row.ruleId) }}</template>
      </el-table-column>
      <el-table-column label="默认群" width="90" align="center">
        <template slot-scope="s">
          <el-switch
            :value="s.row.isDefault === 1"
            @change="toggleDefault(s.row, $event)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" width="170"></el-table-column>
      <el-table-column label="操作" width="320">
        <template slot-scope="s">
          <el-button type="text" @click="openEdit(s.row)">编辑</el-button>
          <el-button type="text" @click="openMembers(s.row)">成员</el-button>
          <el-button
            v-if="s.row.status !== 1"
            type="text"
            style="color:#E6A23C"
            @click="toggleClosed(s.row, true)"
          >关闭群聊</el-button>
          <el-button
            v-else
            type="text"
            style="color:#67C23A"
            @click="toggleClosed(s.row, false)"
          >开启群聊</el-button>
          <el-button type="text" style="color:#F56C6C" @click="remove(s.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top:12px"
      background
      layout="total,sizes,prev,pager,next"
      :total="total"
      :page-sizes="[10, 20, 50, 100, 200]"
      :page-size="size"
      :current-page.sync="page"
      @size-change="onSizeChange"
      @current-change="load"
    ></el-pagination>

    <el-dialog :title="form.id ? '编辑群聊' : '新增群聊'" :visible.sync="dialog" width="520px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="群名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="群头像">
          <el-upload
            action="#"
            :http-request="uploadAvatar"
            :show-file-list="false"
            accept="image/*"
          >
            <div class="group-avatar-uploader">
              <img v-if="form.avatar" :src="form.avatar">
              <i v-else class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="玩法">
          <el-select v-model="form.ruleId" placeholder="一个玩法只能绑一个群" style="width:100%">
            <el-option v-for="r in rules" :key="r.id" :label="r.name" :value="r.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="默认群">
          <el-switch v-model="form.isDefault" :active-value="1" :inactive-value="0"></el-switch>
          <span class="muted" style="margin-left:8px">新用户初次登录将自动加入</span>
        </el-form-item>
        <el-form-item label="群成员">
          <div class="member-select-row">
            <el-select v-model="userIds" multiple filterable style="width:100%" placeholder="选择用户">
              <el-option v-for="u in users" :key="u.id" :label="userLabel(u)" :value="u.id"></el-option>
            </el-select>
            <el-button type="text" @click="selectAllFormUsers">全选玩家</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialog = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="群成员" :visible.sync="memberDialog" width="560px">
      <div class="toolbar member-add-bar">
        <el-select v-model="addIds" multiple filterable placeholder="添加用户" class="member-add-select">
          <el-option v-for="u in addableUsers" :key="u.id" :label="userLabel(u)" :value="u.id"></el-option>
        </el-select>
        <el-button class="ml8" @click="selectAllAddable">全选玩家</el-button>
        <el-button type="primary" class="ml8" @click="addMembers">添加</el-button>
      </div>
      <el-table :data="members" border>
        <el-table-column prop="nickname" label="昵称"></el-table-column>
        <el-table-column prop="username" label="账号"></el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="s">
            <el-button type="text" @click="removeMember(s.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  groups as fetchGroups,
  groupDetail,
  saveGroup,
  upload,
  deleteGroup,
  setDefaultGroup,
  setGroupClosed,
  addMembers as addGroupMembers,
  removeMember as removeGroupMember,
  rules as fetchRules,
  usersAll as fetchUsersAll
} from '../api'

export default {
  name: 'Groups',
  data() {
    return {
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      list: [],
      dialog: false,
      form: { id: null, name: '', avatar: '', ruleId: null, isDefault: 0 },
      avatarUploading: false,
      userIds: [],
      rules: [],
      users: [],
      memberDialog: false,
      currentGroup: null,
      members: [],
      addIds: []
    }
  },
  created() {
    this.load()
    this.loadMeta()
  },
  computed: {
    addableUsers() {
      const memberIds = {}
      this.members.forEach((m) => { memberIds[m.id] = true })
      return this.users.filter((u) => !memberIds[u.id])
    }
  },
  methods: {
    loadMeta() {
      fetchRules({ page: 1, size: 500 }).then((data) => {
        this.rules = (data && data.records) || []
      }).catch((e) => {
        this.$message.error(e.message)
      })
      fetchUsersAll().then((data) => {
        const list = Array.isArray(data) ? data : ((data && data.records) || [])
        this.users = list.filter((u) => u.isRobot !== 1 && u.id !== 1)
      }).catch((e) => {
        this.$message.error(e.message)
      })
    },
    onSizeChange(val) {
      this.size = val
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      fetchGroups({ page: this.page, size: this.size }).then((data) => {
        this.list = data.records || []
        this.total = data.total || 0
      }).catch((e) => {
        this.$message.error(e.message)
      }).then(() => {
        this.loading = false
      })
    },
    ruleName(id) {
      const found = this.rules.filter((r) => r.id === id)[0]
      return found ? found.name : id
    },
    userLabel(u) {
      const base = u.nickname + '（' + u.username + '）'
      return u.remark ? base + ' - ' + u.remark : base
    },
    openCreate() {
      this.form = { id: null, name: '', avatar: '', ruleId: null, isDefault: 0 }
      this.userIds = []
      this.dialog = true
    },
    toggleDefault(row, on) {
      const title = on ? '设为默认群' : '取消默认群'
      const hint = on
        ? '设为默认后，新用户初次登录将自动加入该群。原默认群会被取消。'
        : '取消后，新用户初次登录将不再自动加入该群。'
      this.$confirm(hint, title, { type: 'warning' }).then(() => {
        return setDefaultGroup(row.id, on)
      }).then(() => {
        this.$message.success(on ? '已设为默认群' : '已取消默认群')
        this.load()
      }).catch((e) => {
        this.load()
        if (e === 'cancel' || e === 'close') return
        if (e && e.message) this.$message.error(e.message)
      })
    },
    toggleClosed(row, closed) {
      const title = closed ? '关闭群聊' : '开启群聊'
      const hint = closed
        ? '关闭后，群聊仍可查看历史消息，但所有用户无法发送消息和红包。'
        : '开启后，群成员可正常发送消息和红包。'
      this.$confirm(hint, title, { type: 'warning' }).then(() => {
        return setGroupClosed(row.id, closed)
      }).then(() => {
        this.$message.success(closed ? '群聊已关闭' : '群聊已开启')
        this.load()
      }).catch((e) => {
        this.load()
        if (e === 'cancel' || e === 'close') return
        if (e && e.message) this.$message.error(e.message)
      })
    },
    uploadAvatar(req) {
      this.avatarUploading = true
      upload(req.file, 'avatar').then((d) => {
        this.$set(this.form, 'avatar', d.url)
        req.onSuccess && req.onSuccess(d)
      }).catch((e) => {
        this.$message.error(e.message)
        req.onError && req.onError(e)
      }).then(() => {
        this.avatarUploading = false
      })
    },
    openEdit(row) {
      groupDetail(row.id).then((data) => {
        this.form = {
          id: data.group.id,
          name: data.group.name,
          avatar: data.group.avatar || '',
          ruleId: data.group.ruleId,
          isDefault: data.group.isDefault === 1 ? 1 : 0
        }
        this.userIds = (data.members || []).map((u) => u.id)
        this.dialog = true
      }).catch((e) => {
        this.$message.error(e.message)
      })
    },
    save() {
      saveGroup({ group: this.form, userIds: this.userIds }).then(() => {
        this.$message.success('保存成功')
        this.dialog = false
        this.load()
      }).catch((e) => {
        this.$message.error(e.message)
      })
    },
    remove(row) {
      this.$confirm('确定删除群聊「' + row.name + '」吗？', '提示', { type: 'warning' }).then(() => {
        return deleteGroup(row.id)
      }).then(() => {
        this.$message.success('已删除')
        this.load()
      }).catch((e) => {
        if (e && e.message) this.$message.error(e.message)
      })
    },
    openMembers(row) {
      this.currentGroup = row
      this.addIds = []
      groupDetail(row.id).then((data) => {
        this.members = data.members || []
        this.memberDialog = true
      }).catch((e) => {
        this.$message.error(e.message)
      })
    },
    selectAllFormUsers() {
      this.userIds = this.users.map((u) => u.id)
    },
    selectAllAddable() {
      const ids = this.addableUsers.map((u) => u.id)
      if (!ids.length) {
        this.$message.info('没有可添加的玩家')
        return
      }
      this.addIds = ids
    },
    addMembers() {
      if (!this.addIds.length) return
      addGroupMembers(this.currentGroup.id, this.addIds).then(() => {
        this.$message.success('已添加')
        this.openMembers(this.currentGroup)
        this.addIds = []
      }).catch((e) => {
        this.$message.error(e.message)
      })
    },
    removeMember(user) {
      removeGroupMember(this.currentGroup.id, user.id).then(() => {
        this.openMembers(this.currentGroup)
      }).catch((e) => {
        this.$message.error(e.message)
      })
    }
  }
}
</script>
